import "./SuccessStories.module.css";
import Header from "@/reusable_sections/Header";
import Successcaseshero from "./sections/Successcaseshero";
import SuccessCaseGrid from "./sections/SuccessCaseGrid";
import SuccessCaseGridCopy from "./sections/SuccessCaseGridCopy";
import Footer from "@/reusable_sections/Footer";
export default function SuccessStoriesPage() {
  return <div>
      <Header />
      <Successcaseshero />
      <SuccessCaseGrid />
      <SuccessCaseGridCopy />
      <Footer />
    </div>;
}